import { Pipe, PipeTransform } from "@angular/core";
import { map } from "rxjs/operators";
import { Driver } from "src/app/model/driver.model";
import { RunType } from "src/app/model/run";
import { DispatchService } from "src/app/services/dispatch.service";

/**
 * Get the names of drivers for display.
 */
@Pipe({
  name: 'runTypeName$'
})
export class RunTypeNamePipe implements PipeTransform {
  public constructor(private dispatchService: DispatchService) { }
  
  public transform(args: RunType | RunType[]) {
    const runTypeIds = args instanceof Array
      ? args
      : [args];

    return this.dispatchService
      .runTypes$
      .pipe(
        map((types) => {
          return runTypeIds.reduce((names, runTypeId, index) => {
            const name = types.find((type) => type.id === runTypeId)?.label ?? '';
      
            if(index === 0) {
              return name;
            }
            else if(index + 1 === self.length) {
              return `${names} and ${name}`;
            }
            else {
              return `${names}, ${name}`;
            }
          }, '');
        })
      );
  }
}
